import { EpimsBaseEntityDto } from './epim-base.dto';
export class IndividualAcreagesDto extends EpimsBaseEntityDto {
  IndividualAcreagesId: string;
  TerrainId: string;
  NetArea: number;
  MeasureId: string;
  LessorInfo_LesssorId: string;
  LessorsId: string;
  LandTitleId: string;
  Remarks: string;
  AddressBookId: string;
}
